import {inject, Injectable} from '@angular/core';
import {ProductCategory} from '../master-data/master-data.model';
import {MasterDataService} from '../master-data/master-data-service';
import {Observable} from 'rxjs';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';

@Injectable({providedIn: 'root'})
export class ProductCategoriesResolve {
  private masterDataService = inject(MasterDataService);


  getProductCategories(): Observable<ProductCategory[]> {
    return this.masterDataService.getProductCategories();
  }
}

export const productCategoriesResolver: ResolveFn<ProductCategory[]> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(ProductCategoriesResolve).getProductCategories();
  };
